<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { PageStore } from 'stores/Page/Page.ts';
import { storeToRefs } from 'pinia';

const $route = useRoute();

const search = ref($route.query.s || '');
const searchFocus = ref(false);

const pageStore = PageStore();
const { head } = storeToRefs(pageStore);
</script>

<template>
  <div class="site-search-bar">
    <!-- Call To Action -->
    <div class="octf-btn-cta">
      <div class="octf-header-module" style="visibility: hidden">
        <div class="btn-cta-group">
          <a class="octf-btn octf-btn-secondary" href="#">Müşteri Paneli</a>
        </div>
      </div>
      <div class="octf-header-module">
        <div class="toggle_search octf-cta-icons">
          <i class="flaticon-search"></i>
        </div>
        <!-- Form Search on Header -->
        <div class="h-search-form-field" :class="{ 'search-on-focus': searchFocus }">
          <form role="search" method="get" id="search-form" class="search-form" :action="`${head.title.siteAddress}`">
            <div class="h-search-form-inner">
              <q-icon name="fa-solid fa-magnifying-glass" />
              <input type="search" class="search-field" placeholder="Ürünlerde ara…" v-model="search" name="s" @focus="searchFocus = true" @blur="searchFocus = false" />
            </div>
            <q-btn color="primary" type="submit" no-caps>Ara</q-btn>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.site-search-bar {
  padding-bottom: 2rem;
}

.site-search-bar .h-search-form-inner {
  display: flex;
  min-width: 450px;
  height: 36px;
  padding: 8px 15.209px;
  align-items: center;
  gap: 12.87px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid #1e2a38;
  background: rgba(30, 42, 56, 0.05);
  margin-right: 0.5rem;
  transition: background-color 0.1s ease-in;
}

.search-on-focus .h-search-form-inner {
  background-color: #fff;
}

.site-search-bar form {
  display: flex;
  justify-items: stretch;
}

.site-search-bar form input {
  border: none;
  background-color: transparent;
  outline: none;
  flex-basis: 100%;
}

.site-search-bar input[type='search'] {
  height: 20px;
}
</style>
